module.exports = __webpack_public_path__ + "static/img/gzhCode.139c6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/icon/gzhCode.png
// module id = P+X/
// module chunks = 41